import { UsersTable } from "components";

const Users = () => {



    return (
        <UsersTable/>
    );

}
export default Users;